module.exports = __webpack_public_path__ + "static/media/expensehive-420-280.0943eea8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/layout/assets/expensehive-420-280.jpg
// module id = 89
// module chunks = 0